// extracted by mini-css-extract-plugin
export default {"heading":"Aboutlocaion_heading__UYJwM","about_text":"Aboutlocaion_about_text__2eUrB"};